/**
 * Form/UI helpers: inputs always bind to strings.
 * API/domain layer may use null for absent optional values.
 */

export function nullToEmptyString(value?: string | null): string {
  return value ?? "";
}

export function emptyStringToNull(value?: string | null): string | null {
  const trimmed = value?.trim() ?? "";
  return trimmed === "" ? null : trimmed;
}
